import React from 'react';
import { Link } from 'react-router-dom';

import RubricListItemMeta from './RubricListItemMeta';
import styles from './RubricList.module.scss';

function RubricListItem({ workspaceId, rubric }) {
  return (
    <div className={styles['rubric-list-item']}>
      <div>
        <Link to={`/w/${workspaceId}/rubrics/${encodeURIComponent(rubric.id)}`}>
          {rubric.name}
        </Link>
      </div>
      <RubricListItemMeta rubric={rubric} />
    </div>
  );
}

export default RubricListItem;
